export default __webpack_public_path__ + "static/black-suit-f8099b9f95c2db31e4ab3e5611c6e2f8.webp";